export default __webpack_public_path__ + "static/media/background.622818e3.jpeg";